import React from 'react';
import { LoadingSpinner, PitcherOverviewDamageZones, date } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import ReportCard from '../../../../components/ReportCard';
import { VideoPlayerModal } from '../../../../components/VideoPlayer';
import { usePitchVideoFn, useMultiVideoFn } from '../../../../data';

const tooltipFormatter = (translate) => (series, point) => `
    <b>${series.name}</b><br />\
    ${translate('common.date')}: ${date(point.gamedate)}<br/>
    ${(point.istop ? `${translate('baseball.abbr-top')} ` : `${translate('baseball.abbr-bottom')} `) + point.inning},
    ${point.outs} ${translate('baseball.outs_one')}, ${point.balls}-${point.strikes}
`;

const DamageZones = ({ isLoading, isLhp, isLhb, repertoire, pitches, damageZonesHeatMap, szTop, szBottom }) => {
    const { t: translate } = useTranslation();
    const pitchVideoFn = usePitchVideoFn();
    const multiVideoFn = useMultiVideoFn();

    return (
        <ReportCard title={translate('pitcher-overview.sections.damage-zones')}>
            {isLoading ? <div className="py-5 text-center"><LoadingSpinner /></div> : (
                <div className="text-center">
                    <PitcherOverviewDamageZones
                        isLhb={isLhb}
                        isLhp={isLhp}
                        repertoire={repertoire}
                        pitches={pitches}
                        damageZones={damageZonesHeatMap}
                        translate={translate}
                        pitchVideoFn={pitchVideoFn}
                        multiVideoFn={multiVideoFn}
                        videoPlayerModal={VideoPlayerModal}
                        tooltipFormatter={tooltipFormatter(translate)}
                        sztop={szTop}
                        szbottom={szBottom}
                    />
                </div>
            )}
        </ReportCard>
    );
};

export default DamageZones;
